import { BTUsType, SpaceType } from 'data/types';

const ZERO_BTUS: BTUsType = { heating: 0, cooling: 0, latent: 0 };

function spaceHasLoad(space: SpaceType): boolean {
  const btus = space.BTUs;
  if (!btus) {
    return false;
  }
  return btus.heating !== 0 || btus.cooling !== 0 || (btus.latent ?? 0) !== 0;
}

export function unconditionedSpacesWithLoads(spaces: SpaceType[]): SpaceType[] {
  return spaces.filter(spaceHasLoad);
}

export function zeroBtusBySpaceId(
  spaces: ReadonlyArray<{ uniqueId: string }>
): { [uniqueId: string]: BTUsType } {
  return Object.fromEntries(
    spaces.map((space) => [space.uniqueId, { ...ZERO_BTUS }])
  );
}
